import classnames from 'classnames';
import cn from 'classnames/bind';
import * as React from 'react';
import classes from './index.module.scss.js';

const cx = cn.bind(classes);
const TextLink = React.forwardRef(({ children, size, href, rel, target, weight = 'semibold', disabled = false, themed = true, onClick, classes = [], }, ref) => {
    return (React.createElement("a", { href: href, rel: rel, target: target, className: classnames([
            cx('link', {
                disabled,
                themed: themed && !disabled,
                'extra-small': size === 'xs',
                small: size === 'sm',
                medium: size === 'md',
                book: weight === 'book',
                semibold: weight === 'semibold',
            }),
            ...classes,
        ]), onClick: onClick, ref: ref }, children));
});
TextLink.displayName = 'Link';

export { TextLink };
//# sourceMappingURL=index.js.map
